import { render } from "./SystemPreferenceContactsModal.vue?vue&type=template&id=639deae4"
import script from "./SystemPreferenceContactsModal.vue?vue&type=script&lang=js"
export * from "./SystemPreferenceContactsModal.vue?vue&type=script&lang=js"

import "./SystemPreferenceContactsModal.vue?vue&type=style&index=0&id=639deae4&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__